import { render } from "./QuestionElement.vue?vue&type=template&id=537530b8"
import script from "./QuestionElement.vue?vue&type=script&lang=js"
export * from "./QuestionElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__